// same for documentsToReview and myDocuments
import { FIELDS as TABLE_FILTERS_FIELDS } from 'features/views/productionControl/documentsToReview/form';
import { FIELDS as SEL_CRITERIA_FIELD } from 'features/views/productionControl/selectionCriteria/form';

export const documentTypeIdToTextMap = {
	1: 'PS',
	2: 'ZzJ',
	3: 'IoZ',
};

export const selectionCriteriaBEFilters = ['waveId', 'regionId', 'superiorOid', 'solverOid'];
export const selectionCriteriaBEFiltersMap = {
	waveId: SEL_CRITERIA_FIELD.wave,
	regionId: SEL_CRITERIA_FIELD.region,
	superiorOid: SEL_CRITERIA_FIELD.superior,
	solverOid: SEL_CRITERIA_FIELD.subordinate,
};

export const tableBEFilters = ['policyNo', 'documentState', 'noticeFinalState', 'policyHolder', 'documentType'];
export const tableBEFiltersMap = {
	policyNo: TABLE_FILTERS_FIELDS.policyNumber,
	documentState: TABLE_FILTERS_FIELDS.controlStatus,
	noticeFinalState: TABLE_FILTERS_FIELDS.centralConsent,
	policyHolder: TABLE_FILTERS_FIELDS.client,
	documentType: TABLE_FILTERS_FIELDS.documentType,
};

export const centralConsentNotFilledOption = {
	id: '-1',
	shortDescription: 'Nezadáno',
	description: 'Nezadáno',
};
